// Copyright (c) 2017 Deere & Company

import ProductsByCustomer from '../../product/products-by-customer/state-connector';

export default {
    component: ProductsByCustomer,
    name: 'PRODUCTS_BY_CUSTOMER',
    path: 'products-by-customer'
};



// WEBPACK FOOTER //
// ./src/routes/products/products-by-customer.js